export const appId = 1252152175;
export const serversecret = "b330663a3d45332436966d1365604d46";
